import { render, staticRenderFns } from "./BooleanComponent.vue?vue&type=template&id=47c8fb81&"
import script from "./BooleanComponent.vue?vue&type=script&lang=ts&"
export * from "./BooleanComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports